export class Guides {
  /**
   * Initialize the guides system
   * @param {Object} breakpoints - Media query breakpoints and their column counts
   */
  constructor(
    breakpoints = {
      "(max-width: 1000px)": 6,
    }
  ) {
    this.breakpoints = breakpoints;
    this.guides = document.createElement("div");
    this.guides.className = "guides wrap";

    this.updateColumns();
    document.body.appendChild(this.guides);

    this.checkPreviousState();
    this.setupEventListeners();
  }

  /**
   * 💾 Check if guides were previously enabled in localStorage
   * @private
   * @returns {void}
   */
  checkPreviousState() {
    if (localStorage.getItem("guides") === "true") {
      this.guides.style.visibility = "visible";
    }
  }

  /**
   * ⌨️ Set up event listeners for keyboard shortcuts and window resize
   * @private
   * @returns {void}
   */
  setupEventListeners() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "g" && e.ctrlKey) {
        this.toggleVisibility();
      }
    });

    this.updateWindowWidth();
    window.addEventListener("resize", () => {
      this.updateColumns();
      this.updateWindowWidth();
    });
  }

  /**
   * 🎭 Toggle guides visibility and update localStorage
   * @private
   * @returns {void}
   */
  toggleVisibility() {
    const visible = this.guides.style.visibility === "visible";
    this.guides.style.visibility = visible ? "hidden" : "visible";
    localStorage.setItem("guides", (!visible).toString());
  }

  /**
   * 📏 Get current number of columns based on media queries
   * @private
   * @returns {number} Number of columns to display
   */
  getCurrentColumns() {
    for (const [query, columns] of Object.entries(this.breakpoints)) {
      if (window.matchMedia(query).matches) {
        return columns;
      }
    }
    return 12; // Default fallback
  }

  /**
   * 🔄 Update window width in guides dataset
   * @private
   * @returns {void}
   */
  updateWindowWidth() {
    this.guides.dataset.windowWidth = window.innerWidth.toString();
  }

  /**
   * 🏗️ Update the guides HTML with current column count
   * @private
   * @returns {void}
   */
  updateColumns() {
    const columns = this.getCurrentColumns();
    this.guides.innerHTML = `
      <div class="guides__inner inner grid">
        ${Array(columns).fill('<div class="guides__guide"></div>').join("")}
      </div>
    `;
  }
}
